export default __webpack_public_path__ + "static/media/bg-points-header.3db4ef03.svg";